import type { AppDispatch, RootState } from '../../stores/redux';
import {
  type SurveyCallDetails,
  setupPostCallSurvey,
} from './postCallSurvey.slice';
import { getApolloSessionDetails } from '../apolloSession/apolloSession.selectors';
import { Vendor, media } from '../../webrtc/media';
import { logger } from './logger';
import { type PostCallSurveyCallType } from './postCallSurveyCallType';

export type PromptPostCallSurveyOptions = {
  callType: PostCallSurveyCallType;
};

const checkPresence = (
  obj: Record<string, unknown>,
): obj is SurveyCallDetails =>
  Boolean(obj['dbSessionId']) && Boolean(obj['sessionId']);

export const promptPostCallSurvey =
  ({ callType }: PromptPostCallSurveyOptions) =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const apolloSession = getApolloSessionDetails(getState());
    const { dbSessionId, sessionId } = apolloSession;
    const noSoundDetected = !media.hasAudioAccess;

    const callDetails = {
      dbSessionId,
      sessionId,
      noSoundDetected,
      vendor: Vendor.Vonage,
      callType,
    };

    if (checkPresence(callDetails)) {
      dispatch(setupPostCallSurvey(callDetails));
    } else {
      logger.error('[postCallSurvey/prompt]', 'Failed to open', {
        callDetails,
      });
    }
  };
